import { DotLottie } from '@lottiefiles/dotlottie-web';
import { RevealOnScroll } from '../classes/RevealOnScroll';

document.addEventListener('DOMContentLoaded', () => {
	const LOTTIE_SRC_EN = '/assets/lottiefiles/EN_Sustainability_Cycle_v4.json';
	const LOTTIE_SRC_DE = '/assets/lottiefiles/Sustainability_Cycle_v4.json';

	const isEnglish = document.documentElement.lang === 'en';

	let lottieSrc: string;

	if (isEnglish) {
		lottieSrc = LOTTIE_SRC_EN;
	} else {
		lottieSrc = LOTTIE_SRC_DE;
	}
	
	for (const sustainableAnimation of Array.from(document.querySelectorAll('.sustainable-animation'))) {
		new RevealOnScroll('#' + sustainableAnimation.id, {
			onReveal: (revealedElements) => {
				new DotLottie({
					canvas: revealedElements[0].querySelector('.sustainable-circle__lottiefile') as HTMLCanvasElement,
					src: lottieSrc,
					autoplay: true,
				});
			},
		});
	}
});
